import { langUrl, fallbackTranslations } from "./i18nConfig";
import en from "./lang/en.json";
import th from "./lang/th.json";

// Language files mapping
const languageFiles = {
  th,
  en,
};

export function fetchTranslations(lang) {
  try {
    // Get translations for the requested language
    const translations = languageFiles[lang];

    if (!translations) {
      console.warn(`Language "${lang}" not found, falling back to fallback translations`);
      return { ...fallbackTranslations };
    }

    // Merge with fallback translations to ensure critical keys are always available
    return {
      ...fallbackTranslations,
      ...translations,
    };
  } catch (error) {
    console.error(`Error loading translations for language "${lang}":`, error);
    return { ...fallbackTranslations };
  }
}

// Async version for future use (if loading from external sources)
export async function fetchTranslationsAsync(lang) {
  return new Promise((resolve) => {
    // Simulate async loading (useful for lazy loading or external APIs)
    setTimeout(() => {
      resolve(fetchTranslations(lang));
    }, 100);
  });
}

// Validate if translation object has required keys
export function validateTranslations(translations, requiredKeys = []) {
  const missingKeys = [];

  requiredKeys.forEach((key) => {
    const keys = key.split(".");
    let current = translations;

    for (const nestedKey of keys) {
      if (!current || typeof current !== "object" || !(nestedKey in current)) {
        missingKeys.push(key);
        break;
      }
      current = current[nestedKey];
    }
  });

  if (missingKeys.length > 0) {
    console.warn("Missing translation keys:", missingKeys);
  }

  return missingKeys.length === 0;
}
